export default __webpack_public_path__ + "pypi/streamlit-1.31.0-cp311-none-any.whl";